var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPurchaseSuccess = function SvgPurchaseSuccess(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 86,
    viewBox: "0 0 90 86",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6539 23.595C44.5785 22.4884 44.4603 21.2171 44.3154 20.1213L62.1616 33.2867L44.4415 46.5431L44.6747 39.6492L44.6896 39.2099L44.2559 39.1388C36.1847 37.8156 23.9767 42.0009 16.6993 58.2099C15.9835 52.3629 17.1484 45.1513 20.9655 39.1261C25.1445 32.5299 32.5205 27.3249 44.1883 26.9063C44.455 26.9 44.5882 26.7059 44.621 26.6518C44.6645 26.5803 44.6843 26.5108 44.6935 26.4752C44.7139 26.3961 44.7241 26.3075 44.7304 26.2301C44.7437 26.067 44.7475 25.8461 44.7448 25.5911C44.7394 25.0763 44.7069 24.3714 44.6539 23.595Z",
    fill: "#2648F7",
    stroke: "#3B3F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85C82.2843 85 89 78.2843 89 70C89 61.7157 82.2843 55 74 55C65.7157 55 59 61.7157 59 70C59 78.2843 65.7157 85 74 85Z",
    fill: "#2EDB89",
    stroke: "#3B3F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67L71.5 73L68 69",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49.5V29.75V10C77.6667 7 75.2 1 68 1C60.8 1 26.6667 1 10.5 1C8 1 2.6 2.8 1 10C1 10.5 1.16667 48.5 1 68C0.978632 70.5 3.5 78.5 11.5 78.5C11.8786 78.4 41 78.6667 55.5 78.5",
    stroke: "black",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurchaseSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/purchaseSuccess.d0eaecb5.svg";
export { ForwardRef as ReactComponent };